var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isDraggable
        ? _c(
            "b-upload",
            {
              staticClass: "file-label is-block",
              attrs: {
                accept: _vm.getAcceptMimeTypes(),
                multiple: "",
                "drag-drop": "",
              },
              on: { input: _vm.setFileId },
            },
            [
              _c("section", { staticClass: "section" }, [
                _c("div", { staticClass: "content has-text-centered" }, [
                  _c(
                    "p",
                    [
                      _c("b-icon", {
                        attrs: {
                          pack: "fas",
                          icon: "upload",
                          size: "is-large",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("form.SelectFilesDragAndDrop"))),
                  ]),
                ]),
              ]),
            ]
          )
        : _c(
            "b-upload",
            {
              staticClass: "file-label",
              attrs: { multiple: "", accept: _vm.getAcceptMimeTypes() },
              on: { input: _vm.setFileId },
              model: {
                value: _vm.files,
                callback: function ($$v) {
                  _vm.files = $$v
                },
                expression: "files",
              },
            },
            [
              _c(
                "span",
                { staticClass: "file-cta" },
                [
                  _c("b-icon", {
                    staticClass: "file-icon",
                    attrs: { pack: "fas", icon: "upload" },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "file-label" }, [
                    _vm._v(_vm._s(_vm.buttonLabel)),
                  ]),
                ],
                1
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }